module.exports = __webpack_public_path__ + "static/media/sort-asc.87e97ffc.svg";